import {
	Card,
	CardContent,
	IconButton,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
} from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'

import LoadingScreen from '../../components/custom/LoadingScreen'

import { t } from 'i18next'
import editIcon from '../../assets/svgs/edit.svg'
import plusIcon from '../../assets/svgs/plus.svg'
import referralIcon from '../../assets/svgs/referral.svg'
import searchIcon from '../../assets/svgs/search.svg'
import trashIcon from '../../assets/svgs/trash.svg'

export const eventsText = (text) => t(`events.${text}`)

export default function Events() {
	const _curCard = useRef(null)
	const [events, setEvents] = useState([])
	const [page, setPage] = useState(0)
	const [rowsPerPage, setRowsPerPage] = useState(10)

	const [loaded, setLoaded] = useState(false)
	const handleChangePage = (event, newPage) => {
		setPage(newPage)
	}

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(event)
		setPage(0)
	}

	useEffect(() => {
		setLoaded(true)
	}, [])

	return (
		<>
			{loaded ? (
				<div className="p-6 mb-4">
					<Card>
						<CardContent className="!p-0">
							<div className="flex flex-row items-center justify-between p-7">
								<div className="flex flex-row items-center">
									<div className="bg-gray2 p-3 rounded-lg mr-6">
										<img
											src={referralIcon}
											alt="referral"
											className="w-6 h-6"
										/>
									</div>
									<div className="flex flex-col justify-center items-start">
										<p className="text-base text-black1 font-medium">
											{eventsText('events')}
										</p>
										<div className="flex flex-row justify-center items-center mt-1">
											<div className="text-xl text-black1 font-medium mr-5">
												{events.length} / ∞
											</div>
										</div>
									</div>
									<div className="w-[80px]" />
								</div>
								<div className="flex flex-row justify-start items-center gap-4">
									<div
										className="bg-black1 flex flex-row px-4 py-2 text-white rounded-lg cursor-pointer"
										onClick={() => {
											_curCard.current = null
											// setShowModal(true);
										}}
									>
										<img src={plusIcon} alt="plus" className="mr-2" />
										<span>{eventsText('createEvent')}</span>
									</div>
								</div>
							</div>
						</CardContent>
						<CardContent className="!p-0">
							{events.length ? (
								<>
									<div className="flex flex-col overflow-auto max-h-[70vh]">
										<TableContainer component={Paper}>
											<Table sx={{ minWidth: 650 }} aria-label="simple table">
												<TableHead className="bg-gray7">
													<TableRow>
														<TableCell
															className="!text-gray5 !text-left !font-medium !text-base"
															align="left"
														>
															{eventsText('eventTitle')}
														</TableCell>
														<TableCell
															className="!text-gray5 !text-left !font-medium !text-base"
															align="right"
														>
															{eventsText('created')}
														</TableCell>
														<TableCell
															className="!text-gray5 !text-left !font-medium !text-base"
															align="right"
														>
															{eventsText('status')}
														</TableCell>
														<TableCell
															className="!text-gray5 !text-left !font-medium !text-base"
															align="right"
														>
															{eventsText('responses')}
														</TableCell>
														<TableCell
															className="!text-gray5 !text-left !font-medium !text-base"
															align="right"
														>
															{eventsText('completesAt')}
														</TableCell>
														<TableCell
															className="!text-gray5 !text-left !font-medium !text-base"
															align="right"
														>
															{eventsText('rate')}
														</TableCell>
														<TableCell
															className="!text-gray5 !text-left !font-medium !text-base w-[100px]"
															align="right"
														>
															{eventsText('actions')}
														</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{events
														.slice(
															page * rowsPerPage,
															page * rowsPerPage + rowsPerPage
														)
														.map((row, index) => (
															<TableRow key={index}>
																<TableCell
																	align="left"
																	className="!py-3.5 !text-gray5 !text-left !text-base !font-bold cursor-pointer"
																>
																	{row.eventTitle || '-'}
																</TableCell>
																<TableCell
																	align="left"
																	className="!py-3.5 !text-gray5 !text-left !text-base"
																>
																	{row.created || '-'}
																</TableCell>
																<TableCell
																	align="left"
																	className="!py-3.5 !text-gray5 !text-left !text-base"
																>
																	{row.status || '-'}
																</TableCell>
																<TableCell
																	align="left"
																	className="!py-3.5 !text-gray5 !text-left !text-base"
																>
																	{row.responses || '-'}
																</TableCell>
																<TableCell
																	align="left"
																	className="!py-3.5 !text-gray5 !text-left !text-base"
																>
																	{row.completesAt || '-'}
																</TableCell>
																<TableCell
																	align="left"
																	className="!py-3.5 !text-gray5 !text-left !text-base"
																>
																	{row.rate || '-'}
																</TableCell>
																<TableCell
																	align="left"
																	className="!flex flex-row !text-gray-500 !py-3.5 !text-gray5 !text-left !text-base !justify-left w-[100px]"
																>
																	<IconButton color="secondary">
																		<img src={trashIcon} alt="trash" />
																	</IconButton>
																	<IconButton
																		color="secondary"
																		onClick={(e) => {
																			e.stopPropagation()
																			// Add event handlers for edit action
																		}}
																	>
																		<img src={editIcon} alt="edit" />
																	</IconButton>
																</TableCell>
															</TableRow>
														))}
												</TableBody>
											</Table>
										</TableContainer>
									</div>
									<TablePagination
										rowsPerPageOptions={[10, 25, 100]}
										component="div"
										count={events.length}
										rowsPerPage={rowsPerPage}
										page={page}
										onPageChange={handleChangePage}
										onRowsPerPageChange={handleChangeRowsPerPage}
									/>
								</>
							) : (
								<div className="flex flex-col items-center text-center py-10 mt-4 border border-x-0">
									<div className="bg-gray7 !p-2 rounded-full">
										<div className="bg-black1 !p-2 rounded-full">
											<img src={searchIcon} alt="search" />
										</div>
									</div>
									<span className="text-black1 text-lg">
										{eventsText('noEventsFound')}
									</span>
									<span className="text-gray5 text-base mt-1">
										{eventsText('noEventsDescription')}
									</span>
									<div
										className="bg-black1 flex flex-row px-6 py-2 text-white rounded-lg cursor-pointer mt-4"
										onClick={() => {
											_curCard.current = null
											// setShowModal(true);
										}}
									>
										<img src={plusIcon} alt="plus" className="mr-2" />
										<span>{eventsText('addEvent')}</span>
									</div>
								</div>
							)}
						</CardContent>
					</Card>
				</div>
			) : (
				<LoadingScreen />
			)}
		</>
	)
}
